import React from "react";
import { Spinner } from "react-bootstrap";

const ApiSpinner: React.FC = () => {
  return (
    <div style={{ padding: "36px", textAlign: "center" }}>
      <Spinner animation="border"></Spinner>
    </div>
  );
};

export default ApiSpinner;
